<header>
  <div class="logo-wrapper d-flex align-items-center">
    <button
      class="mobile-menu-toggle"
      (click)="onHamburgerClick()"
      type="button">
      <i class="bi bi-list"></i>
    </button>
    <!-- Hidden by _shell.scss (brand lives in the sidebar); kept for Classic-era markup parity -->
    <img
      width="160px"
      src="../../../../assets/images/Hema_NoSlogan_NoBG.png"
      alt="" />
  </div>
  @if(companyProfileSignal()){
  <div class="company-info-wrapper d-flex align-items-center">
    @if(companyProfileSignal()?.logo){
    <img
      class="mx-2"
      src="{{ companyProfileSignal().logo }}"
      alt="Company Logo" />
    } @else {
    <span class="tenant-avatar" aria-hidden="true">{{ tenantInitial }}</span>
    }
    <p class="company-name">
      {{ currentLanguage === "en" ? companyProfileSignal()?.name :
      companyProfileSignal()?.nameAr }}
    </p>
  </div>
  }
  <div class="info-wrapper">
    <!-- Translation -->
    <div
      class="translate-icon"
      role="button"
      tabindex="0"
      [attr.aria-label]="'Aria.Change-Language' | translate"
      (click)="changeLang()"
      (keydown.enter)="changeLang()"
      (keydown.space)="changeLang()">
      <i class="bi bi-translate"></i>
    </div>
    <!-- Notification  -->
    <div class="notifications-wrapper">
      <button
        class="notification-icon"
        matButton
        matBadge="{{ unreadCount() }}"
        [matBadgeHidden]="unreadCount() === 0"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        (menuOpened)="initNotifications()">
        <i class="bi bi-bell"></i>
      </button>
      <mat-menu #menu="matMenu">
        <div class="notifiction-box" (click)="$event.stopPropagation()">
          @if (notifications().length === 0) {
          <div class="no-notification">
            <p class="fw-bold mb-3 p-3">
              {{ "Notification.Notification" | translate }}
            </p>
            <div class="bell-box">
              <svg
                width="168"
                height="172"
                viewBox="0 0 168 172"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M107 150.709C107 162.031 97.8218 171.209 86.5 171.209C75.1782 171.209 66 162.031 66 150.709H107ZM87 2.70898C96.2169 2.70898 103.689 10.1808 103.689 19.3977L103.689 19.8625C123.134 26.7355 137.066 45.2807 137.066 67.0798L137.066 103.371L137.347 103.372C137.389 108.816 139.192 111.594 142.757 111.706L142.982 111.709C149.619 111.709 155 117.09 155 123.727V129.348C155 135.776 149.789 140.987 143.361 140.987H30.6391C24.211 140.987 19 135.776 19 129.348V123.872C19 117.256 24.2816 111.874 30.8581 111.713L31.1626 111.709C33.7483 111.709 35.6719 110.01 36.9334 106.611L36.9338 67.0798C36.9338 45.2807 50.8657 26.7355 70.3113 19.8625L70.3113 19.3977C70.3113 10.1808 77.7831 2.70898 87 2.70898Z"
                  fill="#E9E9F0" />
                <path
                  d="M150.323 160.909C160.043 160.909 167.923 153.029 167.923 143.309C167.923 133.589 160.043 125.709 150.323 125.709C140.602 125.709 132.723 133.589 132.723 143.309C132.723 153.029 140.602 160.909 150.323 160.909Z"
                  fill="#C93C3C" />
                <path
                  d="M146.403 142.907C146.403 146.447 148.061 148.733 150.846 148.733C153.63 148.733 155.323 146.421 155.323 142.907V142.382C155.323 138.833 153.681 136.556 150.888 136.556C148.087 136.556 146.403 138.868 146.403 142.382V142.907ZM148.723 142.391C148.723 139.925 149.531 138.455 150.863 138.455C152.195 138.455 153.003 139.925 153.003 142.391V142.889C153.003 145.364 152.186 146.843 150.863 146.843C149.539 146.843 148.723 145.364 148.723 142.889V142.391Z"
                  fill="white" />
                <path
                  opacity="0.1"
                  d="M18.2759 40.1525C16.335 29.3835 24.9237 16.6478 34.9798 14"
                  stroke="#1B3554"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  opacity="0.1"
                  d="M2.35711 35.8539C-0.155321 21.9136 10.9626 5.42748 23.98 2"
                  stroke="#1B3554"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <p class="my-2 fw-bold text-center">
              {{ "Notification.No-Notifications" | translate }}
            </p>
            <p class="text-center">
              {{ "Notification.No-Notifications-Msg" | translate }}
            </p>
          </div>
          } @if (notifications().length > 0) {
          <div class="top-box">
            <p>{{ "Notification.Notifications" | translate }}</p>
          </div>
          @for (notification of notifications(); track notification) {
          <div class="" [class.no-read]="!notification.isRead">
            <div
              class="notification-content"
              (click)="gotoDetails(notification)">
              <div class="mx-2">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="17" cy="17" r="17" fill="#474C9E" />
                  <g clip-path="url(#clip0_239_42134)">
                    <path
                      d="M16.0425 24.6094C16.1351 24.9249 16.3274 25.2019 16.5906 25.3989C16.8539 25.596 17.1738 25.7025 17.5026 25.7025C17.8314 25.7025 18.1514 25.596 18.4146 25.3989C18.6779 25.2019 18.8702 24.9249 18.9628 24.6094"
                      stroke="white"
                      stroke-width="1.09375"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M17.5 10.9375V9.29688"
                      stroke="white"
                      stroke-width="1.09375"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M17.5 10.9375C18.9504 10.9375 20.3414 11.5137 21.367 12.5393C22.3926 13.5648 22.9688 14.9558 22.9688 16.4063C22.9688 21.544 24.0625 22.4219 24.0625 22.4219H10.9375C10.9375 22.4219 12.0313 21.0248 12.0313 16.4063C12.0313 14.9558 12.6074 13.5648 13.633 12.5393C14.6586 11.5137 16.0496 10.9375 17.5 10.9375V10.9375Z"
                      stroke="white"
                      stroke-width="1.09375"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_239_42134">
                      <rect
                        width="17"
                        height="17"
                        fill="white"
                        transform="translate(8.75 8.75)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="notification-data">
                <p class="">{{ notification.message | htmlToText }}</p>

                <span>
                  {{ notification.createdOn ? (notification.createdOn + "Z" |
                  localizedDate : (currentLanguage === "ar" ? "yyyy/MM/dd 'في'
                  h:mm a" : "dd/MM/yyyy 'at' h:mm a")) : "-" }}
                </span>
              </div>
            </div>
          </div>
          }
          <div class="more py-2">
            <a
              [routerLink]="['/notifications']"
              (click)="menuTrigger.closeMenu()">
              {{ "Common-Label.More" | translate }}
            </a>
          </div>
          }
        </div>
      </mat-menu>
    </div>

    <div class="dropdown user-wrapper">
      <div
        class="d-flex py-2"
        type="button"
        appDropdownToggle
        aria-expanded="false">
        <div class="">
          <span class="user-avatar" aria-hidden="true">{{ userInitial }}</span>
        </div>

        <div class="d-flex flex-column mx-2">
          <span class="name">{{ user?.username }}</span>
          <span class="role font-14 light">{{ user?.role }}</span>
        </div>
      </div>
      <div class="dropdown-menu user-info text-start-dir">
        <!-- <a class="py-3 font-14  company-link" [routerLink]="['/company-profile']">{{
          "Company-Profile.Title" | translate
        }}</a> -->
        <div>
          <p class="role font-14 light">
            {{ "Common-Label.Email" | translate }} :
          </p>
          <p>{{ userMail }}</p>
        </div>
        <div>
          <p class="role font-14 light">
            {{ "Common-Label.Department" | translate }} :
          </p>
          <p class="m-0">
            {{ user?.departmentName ? user?.departmentName : ("Not-Assigned" |
            translate) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</header>
